// extracted by mini-css-extract-plugin
export default {"Container":"Index_Container__JOgmJ","Title":"Index_Title__8xbzP","Cards":"Index_Cards__mLlLV"};